import React from 'react';
import DashboardLayout from 'containers/DashboardLayout';
import MainLayout from 'containers/MainLayout';
import Campaign from 'pages/Campaign';
import Dashboard from 'pages/Dashboard';
import Gamification from 'pages/Gamification';
import Login from 'pages/Login';
import Roles from 'pages/Roles';
import Segment from 'pages/Segment';
import SegmentTarget from 'pages/SegmentTarget';
import Users from 'pages/User';
import Fcms from 'pages/FCMMaster';
import CampaignTarget from 'pages/CampaignTarget';
import MasterTier from 'pages/MasterTier';
import RoleAccess from 'pages/RoleAccess';
import LogPointGamification from 'pages/LogPointGamification';
import CustomerDataPlatform from 'pages/CustomerDataPlatform';
import FormCustomerDataPlatform from 'pages/CustomerDataPlatform/form';
import SSOCallback from 'pages/SsoCallback';

const routes = [
  {
    path: '/',
    element: <DashboardLayout />,
    children: [
      { path: '', element: <Dashboard /> },
      {
        path: 'roles',
        element: <Roles />
      },
      {
        path: 'users',
        element: <Users />
      },
      {
        path: 'gamification',
        element: <Gamification />
      },
      {
        path: 'log-point-gamification',
        element: <LogPointGamification />
      },
      {
        path: 'segment',
        element: <Segment />
      },
      {
        path: 'segment-target',
        element: <SegmentTarget />
      },
      {
        path: 'campaign',
        element: <Campaign />
      },
      {
        path: 'campaign-target',
        element: <CampaignTarget />
      },
      {
        path: 'customer-fcm',
        element: <Fcms />
      },
      {
        path: 'master-tier',
        element: <MasterTier />
      },
      {
        path: 'role-access',
        element: <RoleAccess />
      },
      {
        path: 'customer-data-platform',
        element: <CustomerDataPlatform />
      },
      {
        path: 'customer-data-platform/:id',
        element: <FormCustomerDataPlatform />
      },
      {
        path: 'api/auth/callback/sso',
        element: <SSOCallback />
      }
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [{ path: 'login', element: <Login /> }]
  }
];

export default routes;
